/// <reference path="../../../../typings/index.d.ts" />
///<reference path="alertsLog.service.ts"/>
///<reference path="../../components/controls/presets/presets-list.ts"/>

module Meevo.Plugins.AlertsLog {
    'use strict';

    import IAlertLogUserListItem = Meevo.Model.IAlertLogUserListItem;
    import IAlertUserListItem = Meevo.Model.IAlertUserListItem;
    import IAlert = Meevo.Model.IAlert;
    import IAlertLogDetailListItem = Meevo.Model.IAlertLogDetailListItem;
    import PresetStatus = Meevo.Components.Controls.PresetStatus;
    import IAlertLog = Meevo.Model.IAlertLog;
    import SecurityKeys = Meevo.Components.Common.SecurityKeys;
    import IAlertCatListItem = Meevo.Model.IAlertCatListItem;

    interface ICriteria {
        startTime: Date;
        endTime: Date;
        userId: Guid;
        catId: number;
        includeRead?: boolean;
    }

    interface ICriteriaTypeAhead {
        user: IAlertUserListItem;
        alertCat: IAlertCatListItem;
    }

    interface IAlertsLogController {
        criteria: ICriteria;
        alertCriteria: Object;
        alertsLogUserPages: Object;
        selectedItem: IAlertLogUserListItem;
        criteriaTypeAhead: ICriteriaTypeAhead;

        closeContext: () => void;
        defaultCriteria: () => ICriteria;
        onPageLoad: (isNewPage?: boolean) => void;
        getAlertList: (item, pane) => void;
        criteriaChanged: (isDateChanged?: boolean) => void;
        showAlertsDetails: (alert: IAlertLogDetailListItem) => void;
        // for pager
        forcePageLoading: (criteria: ICriteria) => void;
    }

    const PRESET_LIST = [
        { name: 'LABEL_CUSTOM', status: PresetStatus.Custom },
        { name: 'LABEL_TODAY', status: PresetStatus.Today },
        { name: 'LABEL_YESTERDAY', status: PresetStatus.Yesterday },
        { name: 'LABEL_THIS_WEEK', status: PresetStatus.ThisWeek },
        { name: 'LABEL_LAST_WEEK', status: PresetStatus.LastWeek },
        { name: 'LABEL_PREVIOUS_TWO_WEEKS', status: PresetStatus.PreviousTwoWeeks },
        { name: 'LABEL_THIS_MONTH', status: PresetStatus.ThisMonth },
        { name: 'LABEL_LAST_MONTH', status: PresetStatus.LastMonth },
        { name: 'LABEL_THIS_QUARTER', status: PresetStatus.ThisQuarter },
        { name: 'LABEL_LAST_QUARTER', status: PresetStatus.LastQuarter },
        { name: 'LABEL_THIS_YEAR', status: PresetStatus.ThisYear },
    ];

    class AlertsLogController implements IAlertsLogController {
        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            'meevo.components.common.IdentityService',
            'meevo.plugins.alertsLog.AlertsLogService',
            'restServer'
        ];
        private _currentUser = this.identityService.current();
        public criteria: ICriteria = {
            startTime: null,
            endTime: null,
            userId: this._currentUser.userId,
            catId: null
        };
        public alertCriteria = {
            itemsPerPage: 15,
            criteria: {
                startTime: null,
                endTime: null,
                triggeredByUserId: null,
                triggeredToUserId: null,
                catId: null,
                includeRead: false
            },
            locale: this.appSettings.APP_COUNTRYID,
            timeFormat: this.appSettings.APP_TIME_FORMAT
        };
        public alertsLogUserPages;
        public selectedItem: IAlertLogUserListItem;
        public criteriaTypeAhead: ICriteriaTypeAhead = {
            user: {
                employeeCode: this._currentUser.userName,
                user_TId: this._currentUser.userId
            },
            alertCat: null
        };
        public presetList = PRESET_LIST;

        public minDate = moment().subtract(1, 'year').toDate();
        public maxDate = moment().toDate();

        constructor(
            protected $scope: angular.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: angular.ui.IState,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected alertsLogService: Meevo.Plugins.AlertsLog.IAlertsLogService,
            protected restServer: any
        ) {
            let contextHasClosed: Function;

            this.$scope.$on('alertsLogAccordion:onExpandAnimationEnd', () => {
                if (this.selectedItem.alertList) return;

                this.selectedItem.alertList = new Meevo.Components.BaseClasses.PagedResults(this.dataService, 'alertLogDetail');
                this.selectedItem.alertList.initSearch(this.alertCriteria);
            });

            contextHasClosed = this.$rootScope.$on(Meevo.Components.Common.Messages.CONTEXT_HAS_CLOSED, () => {
                this.cleanReadAlerts();
                contextHasClosed();
            });
        }
        /**
         * Close current tab
         * */
        closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }

        /**
         * Clean read alerts
         */
        cleanReadAlerts(): void {
            this.alertsLogService.markAsRead();
        }

        /**
         * Get criteria for Pager
         */
        defaultCriteria(): ICriteria {
            return this.criteria;
        }

        /**
         * Callback from Pager when selected page is loaded
         * @param {boolean} isNewPage
         */
        onPageLoad(isNewPage: boolean) {
            if (isNewPage || !this.alertsLogUserPages.pages[this.alertsLogUserPages.currentPage]) return;

            this.alertsLogUserPages.pages[this.alertsLogUserPages.currentPage].forEach((e) => {
                e.isExpanded = false;
            });
        }

        /**
         * Get Alerts
         * @param item
         * @param pane
         */
        getAlertList(item: IAlertLogUserListItem, pane): void {
            this.selectedItem = item;
            this.alertCriteria.criteria.triggeredByUserId = item.triggeredByUserId;
            this.alertCriteria.criteria.triggeredToUserId = item.triggeredToUserId;

            this.alertCriteria.criteria.startTime = this.criteria.startTime;
            this.alertCriteria.criteria.endTime = this.criteria.endTime;
            this.alertCriteria.criteria.catId = this.criteria.catId;
            this.alertCriteria.criteria.includeRead = this.criteria.includeRead;
            pane.toggle();
        }

        /**
         * Filter List
         */
        criteriaChanged(isDateChanged?: boolean): void {
            let userId: Guid = this.criteriaTypeAhead.user ? this.criteriaTypeAhead.user.user_TId : null,
                catId: number = this.criteriaTypeAhead.alertCat ? this.criteriaTypeAhead.alertCat.cat_SId : null,
                doFetch: boolean = false;

            if (isDateChanged) {
                doFetch = true;
                this.criteria.includeRead = true;
            }

            if (userId !== this.criteria.userId) {
                this.criteria.userId = userId;
                doFetch = true;
            }

            if (catId !== this.criteria.catId) {
                this.criteria.catId = catId;
                doFetch = true;
                this.criteria.includeRead = true;
            }

            if (doFetch) {
                this.forcePageLoading(this.criteria);
            }
        }

        /**
         * Show details for particular Alert
         * @param {IAlertLogDetailListItem} alert
         */
        showAlertsDetails(alert: IAlertLogDetailListItem): void {
            let url = `api/alertLog/${alert.id}`;
            let params = {
                triggeredByUserId: alert.triggeredByUserId,
                triggeredToUserId: this.selectedItem.triggeredToUserId,
                locale: this.appSettings.APP_COUNTRYID,
                timeFormat: this.appSettings.APP_TIME_FORMAT
            }

            this.busyService.start();
            this.dataService.customMethodData(url, 'GET', null, params)
                .then((response) => {
                    let item: IAlertLog = response.data || {};
                    let requestStateJson: any = {};
                    let additionalButtons = <Meevo.Components.Modal.IModalAdditionalButton[]>[];
                    try {
                        requestStateJson = JSON.parse(item.requestStateJson);
                        if (typeof requestStateJson.ClientId === 'string') {
                            additionalButtons.push({
                                contentKey: 'LABEL_GO_TO_FORM',
                                callback: () => {
                                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                                        stateName: this.appSettings.ROUTE_NAMES.client,
                                        stateParams: {
                                            actionState: Meevo.Model.MaintenanceFormState.Readonly,
                                            targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                                            initialEditSection: 'HERO_SUB_DOCS_AND_FORMS',
                                            id: requestStateJson.ClientId,
                                        },
                                    });
                                    this.modalService.hide();
                                }
                            });
                        }

                        if (typeof requestStateJson.AppointmentId === 'string') {
                            additionalButtons.push({
                                contentKey: 'LABEL_GO_TO_APPOINTMENT',
                                callback: () => {
                                    this.restServer.getAppointment(requestStateJson.AppointmentId)
                                        .then(response => {
                                            let appointmentServise = response.data.services.find(item => item.id === requestStateJson.ItemId);
                                            if (appointmentServise) {
                                                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                                                    stateName: this.appSettings.ROUTE_NAMES.appointmentBook,
                                                    stateParams: {
                                                        actionState: Meevo.Model.AppointmentBookState.EditAppointment,
                                                        actionStatePayload: {
                                                            startDateTime: requestStateJson.AppointmentTime,
                                                            appointmentId: requestStateJson.AppointmentId,
                                                            id: requestStateJson.ItemId,
                                                            appointmentDate: requestStateJson.AppointmentTime,
                                                        },
                                                    },
                                                });
                                            } else {
                                                return this.modalService.alert("MESSAGE_APPOINTMENT_CANCELED_OR_UPDATED");
                                            }
                                        })
                                    this.modalService.hide();
                                }
                            });
                        }

                        if (typeof requestStateJson.TransactionNumber === 'string') {
                            additionalButtons.push({
                                contentKey: 'LABEL_GO_TO_TRANSACTION',
                                callback: () => {
                                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                                        stateName: this.appSettings.ROUTE_NAMES.transactionEditor,
                                        stateParams: {
                                            transactionId: requestStateJson.TransactionNumber,
                                            includeActive: true,
                                            includeCompleted: true,
                                            includeOnHold: false,
                                            includeRefunded: true,
                                            includeVoided: true
                                        },
                                    });
                                    this.modalService.hide();
                                }
                            });
                        }

                        if (Array.isArray(requestStateJson.ProductLots)
                            && requestStateJson.AlertType === Meevo.Model.ProactiveAlertTypeEnum.InventoryProductLotExpired) {
                            additionalButtons.push({
                                contentKey: 'LABEL_GO_TO_INVENTORY_RETURNS',
                                callback: () => {
                                    this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                                        stateName: this.appSettings.ROUTE_NAMES.inventoryReturns,
                                        stateParams: {}
                                    });
                                    this.modalService.hide();
                                }
                            });
                        }
                    } catch (e) {
                    }

                    let options: Meevo.Components.Modal.IModalOptions = {
                        templateUrl: 'app/components/modal/modal.template.html',
                        controller: 'meevo.components.modal.ModalController',
                        controllerAs: 'vm',
                        bindToController: true,
                        skipHide: true,
                        additionalClassName: 'alerts-log-modal-details',
                        locals: {
                            message: item.htmlMessage,
                            modalType: null,
                            headerContentKey: 'LABEL_DETAILS',
                            showOkButton: true,
                            okButtonContentKey: 'LABEL_OK',
                            additionalButtons: additionalButtons,
                        }
                    };

                    this.modalService.showCustom(options);
                })
                .finally(() => {
                    this.alertsLogService.updateAlertsCount();
                    this.busyService.stop();
                });
        }

        // for pager
        forcePageLoading(criteria: ICriteria): void { }

        get presetStatus(): any {
            return PresetStatus;
        }

        get securityKeys(): any {
            return SecurityKeys;
        }
    }
    angular.module('meevo.plugins.alertsLog')
        .controller('meevo.plugins.alertsLog.AlertsLogController', AlertsLogController);
}
